app.factory(
    'BoxLoading', function () {
        return {
            start : function (elem) {
                var overlay = $(elem).find('.loading.overlay');
                if (overlay.length === 0) {
                    $(elem).append('<div class="loading overlay"><i class="fa fa-refresh fa-spin"></i></div>');
                } else {
                    overlay.show();
                }
            },
            stop : function (elem) {
                var overlay = $(elem).find('.loading.overlay');
                if (overlay.length > 0) {
                    overlay.hide();
                }
            }
        };
    }
);